var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMicrophone2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5V11C14 12.1046 13.1046 13 12 13C10.8954 13 10 12.1046 10 11V5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5ZM8 5C8 2.79086 9.79086 1 12 1C14.2091 1 16 2.79086 16 5V11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11V5ZM5.92832 11.01C6.47507 10.9321 6.9815 11.3121 7.05945 11.8589C7.41051 14.3212 9.29223 16 11.9998 16C14.7074 16 16.5891 14.3212 16.9401 11.8589C17.0181 11.3121 17.5245 10.9321 18.0713 11.01C18.618 11.088 18.9981 11.5944 18.9201 12.1411C18.4704 15.2957 16.1646 17.5474 13 17.9392V21H16C16.5523 21 17 21.4477 17 22C17 22.5523 16.5523 23 16 23H12H8C7.44772 23 7 22.5523 7 22C7 21.4477 7.44772 21 8 21H11V17.9392C7.83515 17.5476 5.52924 15.2958 5.07947 12.1411C5.00152 11.5944 5.38156 11.088 5.92832 11.01Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicrophone2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconMicrophone2.dae730bfe79984839aedd30cf091c662.svg";